<script>
// import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import animationJson from '@/assets/animations/transf_anim.json'
import {Vue3Lottie} from "vue3-lottie";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Editar Caixas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie },//Multiselect
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      animationJson,
      loadingCaixas: false,
      errosValid: null,
      caixaData: {
        id: 0,
        status: 'A',
      },
      idData: 0,
      updating: true,
      submitted: false,

      title: "Editar Caixa",
      items: [
        {
          text: "Caixas",
          href: "/caixas/list",
        },
        {
          text: "Editar Caixa",
          active: true,
        },
      ],

    };
  },
  validations: {
    caixaData: {
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    },

  },
  methods: {

    carregarDados(){
      console.log('mounted_caixas_editar_0')
      let rota = this.$route.path
      // console.log(rota)
      let ultimaBarra = rota.lastIndexOf('/')
      if (ultimaBarra){
        this.idData = parseInt(rota.substring(ultimaBarra + 1))
      }
      console.log(`idData: ${this.idData}`)
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/caixa`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios mounted')
          console.log(res.data)
          this.caixaData = res.data[0]

          if (this.caixaData.ori === null){
            this.caixaData.ori = '0'
          }

          this.idData = this.caixaData.id
          this.title = `Editar Caixa (${this.caixaData.id}) ${this.caixaData.descricao}`
          this.updating = false
        });
      }else{
        this.title = `Criando Nova Caixa`
        this.updating = false
      }
    },

    salvar(){
      this.submitted = true;
      this.v$.$touch()
      console.log('salvarCaixa')
      if (this.caixaData.descricao && this.caixaData.descricao !== ''){
        console.log('salvarCaixa_00')
        this.updating = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/caixa`, {
          caixaData: this.caixaData
        }).then((res) => {
          console.log('then axios salvar')
          console.log(res)
          this.caixaData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.idData = this.caixaData.id

          if (this.idData > 0){
            console.log('redirecionar')
            this.$router.replace({ path: `/caixas/list` })
            // this.carregarDados()
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })



      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor preencher descrição antes de salvar a caixa",
          showConfirmButton: false,
          timer: 1500
        })
      }


    },

    voltalist() {
      console.log('voltar para list')
      this.$router.replace({ path: `/caixas/list` })
    },

    calculaDimens() {
      console.log('calculaDimens')

      if(this.caixaData && this.caixaData.altura && this.caixaData.largura && this.caixaData.comprimento) {

        const altura = this.caixaData.altura / 100;
        const largura = this.caixaData.largura / 100;
        const comprimento = this.caixaData.comprimento / 100;

        this.caixaData.cubagem = altura * largura * comprimento;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Necessário altura, largura e comprimento para calcular dimensão!",
          showConfirmButton: false,
          timer: 2000
        })
      }

      this.salvar()

    },

    formatDecimal(value) {
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      }
      return "0,00";
    },
  },
  mounted() {
    this.carregarDados()
  }
};
</script>

<template>
  <Layout>


    <Vue3Lottie :animationData="animationJson" class="float-end" style="z-index: 1000; position: absolute; top: 20px; right: 180px; height: 250px; width: 250px"/>


    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="checkout-tabs" v-if="!updating">

        <div class="card">
          <div class="card-body">

            <div class="d-flex align-items-start mb-2">
              <b-button variant="outline-primary" class="mx-2" @click="salvar">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>
              <b-button variant="primary" title="Voltar para List" class="ms-auto" @click="voltalist">
                voltar
                <i class="bx bx-right-arrow-alt font-size-16 align-middle ms-2"></i>
              </b-button>
            </div>

            <hr class="mb-5">

            <form class="needs-validation mb-4">
              <div class="row">
                <div class="col-md-5">
                  <div class="mb-3">
                    <label for="descricao">Descrição</label>
                    <input
                        id="descricao"
                        v-model="caixaData.descricao"
                        type="text"
                        class="form-control"
                        placeholder="Descrição"
                        maxlength="60"
                        :class="{'is-invalid': submitted && v$.caixaData.descricao.$error,}"/>
                    <div v-if="submitted && v$.caixaData.descricao.$error"
                         class="invalid-feedback">
                      <span v-if="v$.caixaData.descricao.required.$message">{{ v$.caixaData.descricao.required.$message }}</span>
                    </div>
                  </div>
                </div>


                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="codigo">Código</label>
                    <input
                        id="codigo"
                        v-model="caixaData.codigo"
                        type="text"
                        class="form-control"
                        placeholder="Código"
                        :class="{'is-invalid': submitted && v$.caixaData.codigo.$error,}"/>
                    <div v-if="submitted && v$.caixaData.codigo.$error" class="invalid-feedback">
                      <span v-if="v$.caixaData.codigo.required.$message">{{ v$.caixaData.codigo.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="peso">Peso Padrão (Kg)</label>
                    <input id="peso"
                           type="number"
                           v-model="caixaData.peso"
                           class="form-control text-end"
                           placeholder="Peso Padrão (Kg)"
                    />
                  </div>
                </div>

                <div class="col-sm-2 ms-auto">
                  <div class="mb-3 align-items-start align-content-start float-start">
                    <h5 class="font-size-16 mt-2">Status</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="A"
                        unchecked-value="I"
                        v-model="caixaData.status">
                      {{ caixaData.status === 'A' ? 'Ativo' : 'Inativo' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-3">
                  <b-button variant="warning" class="mx-2" style="font-size: 10px" @click="calculaDimens">
                    Calcular Dimens.(m³)
                  </b-button>
                </div>
              </div>

              <div class="row  mt-2">
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="dimen">Altura (cm)</label>
                    <div class="position-relative">
                      <input id="dimen"
                             type="number"
                             v-model="caixaData.altura"
                             class="form-control text-end"
                             placeholder="Altura (cm)"/>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="dimen">Largura (cm)</label>
                    <div class="position-relative">
                      <input id="dimen"
                             type="number"
                             v-model="caixaData.largura"
                             class="form-control text-end"
                             placeholder="Largura (cm)"/>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="dimen">Comprimento (cm)</label>
                    <div class="position-relative">
                      <input id="dimen"
                             type="number"
                             v-model="caixaData.comprimento"
                             class="form-control text-end"
                             placeholder="Comprimento (cm)"
                             @keypress.enter="calculaDimens"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="dimen">Cubagem (m³)</label>
                    <div class="position-relative">
                      <input id="dimen"
                             type="number"
                             v-model="caixaData.cubagem"
                             class="form-control text-end"
                             placeholder="Cubagem (m³)"/>
                    </div>
                  </div>
                </div>

              </div>
            </form>



          </div>
        </div>
    </div>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

  </Layout>
</template>
